<template>
    <div v-if='contacts' >
        <div class="Modal__header">
            <h3>Supprimer les participants ?</h3>
        </div>

        <div class="Modal__body"  >
            <p>Vous êtes sur le point de supprimer définitivement le {{ contacts.length }} participant(s)</p>
            <p>Toutes les données relatives à ces participants seront également supprimées.</p>
        </div>

        <div class="Modal__footer">
            <button class="Modal__buton-ok" @click="cancel()">
                Annuler
            </button>
            <button class="Modal__buton-danger" @click="confirm()">
                Supprimer
            </button>
        </div>
    </div>
</template>

<script>
    /* See https://adamwathan.me/2016/01/04/composing-reusable-modal-dialogs-with-vuejs/ */
    import { deleteContact } from '../../vuex/actions/contactActions'

    export default{
      props: ['contacts'],
      vuex: {
        actions: {
          deleteContact
        }
      },
      data () {
        return {}
      },
      methods: {
        cancel () {
          this.$dispatch('closeModal')
        },
        confirm () {
          let that = this
          this.contacts.forEach(function (contact) {
            that.deleteContact(contact)
          })
          this.$dispatch('closeModal')
          this.$dispatch('after-delete-contacts')
          this.$dispatch('preview-data', [])
        }
      }
}
</script>



// WEBPACK FOOTER //
// DeleteContacts.vue?4f15e89c